export default {
  computed: {
	hrefLink() {
	  return this.data.link_url;
	},
	tagName() {
	  return this.$IS_PREVIEW ? 'div' : 'a';
	},
	className() {
	  const config = this.config;
	  let cls = "goods-card";
	  if (config.goods_list_style === 2) cls += ' list';
	  cls += this.isBig ? ' big' : ' small';
	  cls += " goods-card__" + this.index;
	  return cls;
	},
	infoClass() {
	  let cls = "goods-card_info";
	  return cls + " goods-card_align-" + this.config.text_align_type;
	},

	cornerIcon() {
	  return ["buy_corner_xin", "buy_corner_re", "buy_corner_new", "buy_corner_hot"][this.config.corner_mark_type];
	},
	fit() {
	  if (this.config.image_fill_style === 0) return "cover";
	  return "contain";
	},
	ratio() {
	  return ["66.67%", "100%", "133.33%", "56.25%"][this.config.image_scale];
	},
	width() {
	  if (this.config.goods_list_style === 1) return "50%";
	  if (this.config.goods_list_style === 3) {
		if (this.index % 3 !== 0) return "50%";
	  }
	  return "100%";
	},
	isBig() {
	  if (this.config.goods_list_style === 0) return true;
	  if (this.config.goods_list_style === 3) {
		return !(this.index % 3);
	  }
	  return false;
	},
	cardStyle() {
	  const style = this.config.goods_border_style;
	  return {
		borderRadius: ["", "6px"][this.config.goods_radius_type],
		margin: (this.config.goods_margin / 2) + "px",
		backgroundColor: ["#fff", "#fff", "#fff", "transparent"][style],
		border: style === 2 ? "1px solid #e5e5e5" : "",
		boxShadow: style === 1 ? "2px 0 8px rgba(0,0,0,0.08)" : ""
	  };
	},
	showInfo() {
	  return this.config.show_title || (
		  this.config.show_price || this.config.show_origin_price || this.config.show_buy_btn
	  );
	}
  }
};
